import ServiceRequestsContainer from "../containers/ServiceRequests/ServiceRequestsContainer";
import AdminServiceRequestsContainer from "../containers/ServiceRequests/AdminServiceRequestsContainer";
import UserListContainer from "../containers/Users/UserListContainer";
import ReportContainer from "../containers/Reports/ReportContainer";
import AllServiceReportContainer from "../containers/Reports/AllServiceReportContainer";
import PaymentTrackerContainer from "../containers/Reports/PaymentTrackerContainer";
import LogoutContainer from "../containers/Login/LogoutContainer";
import AdminServiceProgressionContainer from "../containers/ServiceProgression/AdminServiceProgressionContainer";
import FacilitatorServiceProgressionViewContainer from "../containers/ServiceProgression/FacilitatorServiceProgressionViewContainer";
import ThreeSixtyDegreeViewContainer from "../containers/ThreeSixtyDegreeView/ThreeSixtyDegreeViewContainer";
import ThreeSixtyDegreeViewContainerNew from "../containers/ThreeSixtyDegreeView/ThreeSixtyDegreeViewContainerNew";
import FacilitatorActionsViewContainer from "../containers/ServiceProgression/FacilitatorActionsViewContainer";
import ServicePackagingContainer from "../containers/ServicePackaging/ServicePackagingContainer";
import AdminSPLedServiceRequestsView from "../containers/SPLedAdminView/AdminSPLedServiceRequestsView";
import AdminSPLedDashboardView from "../containers/SPLedAdminView/AdminSPLedDashboardView";
import FacilitatorKRADashboardContiner from "../containers/FacilitatorKRADashborad/FacilitatorKRADashboardContiner";
import AdminUploadReport from "../containers/FacilitatorKRADashborad/AdminUploadReport";
import ManagersFacilitatorKRADashboardContainer from "../containers/FacilitatorKRADashborad/ManagersFacilitatorKRADashboardContainer"
import UserProfileSearchAndViewContainer from "../containers/UserProfileSearchAndView/UserProfileSearchAndViewContainer";
import MarkOutOfOfficeContainer from "../containers/FacilitatorMarkOutOfOfficeContainer/MarkOutOfOfficeContainer";
import EServicePartnerDashboard from "../containers/EServicePartnerServiceRequests/EServicePartnerDashboard";
import EngagedUsersReportDashboard from "../containers/EServicePartnerServiceRequests/EngagedUsersReportDashboard";
import EServicePartnerServiceRequest from "../containers/EServicePartnerServiceRequests/EServicePartnerServiceRequest";
import ESPTargetConfiguration from "../containers/EServicePartnerServiceRequests/ESPTargetConfiguration";
import DNDExpirationUsersContainer  from "../containers/ServiceProgression/DNDExpirationUsersContainer";
import AdminServiceRequestAssignmentContainer from "../containers/ServiceRequests/AdminServiceRequestAssignmentContainer";
import AdminServiceProgressionViewContainer from "../containers/ServiceProgression/AdminServiceProgressionViewContainer";
import MyServiceRequestsContainer from "../containers/ServiceRequests/MyServiceRequestsContainer";
import ReportsContainer from "../containers/Reports/ReportsContainer";
import FacilitatorActionsContainer from "../containers/ServiceProgression/FacilitatorActionsContainer";
import FacilitatorServiceProgressionContainer from "../containers/ServiceProgression/FacilitatorServiceProgressionContainer";
import AdminResourceAssignmentContainer from "../containers/ServiceRequests/AdminResourceAssignmentContainer";
import MyResourceAssignmentContainer from "../containers/ServiceProgression/MyResourceAssignmentContainer";
import ToolsTemplatesActionContainer from "../containers/ServiceProgression/ToolsTemplatesActionContainer";
import EngagedUsersReportContainer from "../containers/EServicePartnerServiceRequests/EngagedUsersReportContainer";
import AdminExpertAppointmentContainer from "../containers/AdminExpertAppointmentContainer/AdminExpertAppointmentContainer";
import AdminExpertCalendarContainer from "../containers/AdminExpertAppointmentContainer/AdminExpertCalendarContainer";
import ESPSubscribersInterface from "../containers/EServicePartnerServiceRequests/ESPSubscribersInterface";

import AssignedFacilitatorContainer from "../containers/AssignedFacilitatorDashboard/AssignedFacilitatorContainer";
import AdminExpertSlots from "../containers/AdminExpertAppointmentContainer/AdminExpertSlots";
import NewAndEngagedUserHome from "../containers/NewAndEngagedUserDashboard/NewAndEngagedUserHome";
import PartyInvoiceMainContainer from "../containers/PartyInvoiceInterface/PartyInvoiceMainContainer";
import JpmcDashboardContainer from "../containers/JpmcDashboard/JpmcDashboardContainer";
import ClosedServiceInterface from "../containers/ClosedServiceInterface/ClosedServiceInterface";
import MyServiceRequestsContainerNew from "../containers/ServiceRequests/MyServiceRequestContainerNew";
import ServiceCatalogueHome from "../containers/ServiceCatalogue/ServiceCatalogueHome";
import ResourceMasterHome from "../containers/ResourceMaster/ResourceMasterHome";
import ManageExternalPartnerHome from "../containers/ManageExternalPartner/ManageExternalPartnerHome";
import JpmcExpenseDashboardContainer from "../containers/JpmcExpenseDashboard/JpmcExpenseDashboardContainer";
import ProgramManagerMasterHome from "../containers/ProgramManagerMaster/ProgramManagerMasterHome";
import PartnerMasterHome from "../containers/PartnerMaster/PartnerMasterHome";
import ProgramManagerPartnerAssociationHome from "../containers/ProgramManagerPartnerAssociation/ProgramManagerPartnerAssociationHome";
import IhclDashboardContainer from "../containers/IhclDashboard/IhclDashboardContainer";
import JpmcThreeSixtyDegreeViewContainer from "../containers/jpmcThreeSixtyDegreeView/JpmcThreeSixtyDegreeViewContainer";
import DreamBigNewAndEngagedUserHome from "../containers/DreamBigNewAndEngagedUserDashboard/DreamBigNewAndEngagedUserHome";
import JPMCTestimonials from "../containers/jpmcThreeSixtyDegreeView/JPMCTestimonials";
import AnekDashboardContainer from "../containers/AnekDashboard/AnekDashboardContainer";
import InterventionsAvailedReports from "../containers/AnekDashboard/InterventionsAvailedReports";

export const routes = [
	{
		key: "FACILITATOR_ACTIONS_VIEW_CONTAINER_OLD",
		path: "/home/facilitator-actions-view-container-old/",
		component: FacilitatorActionsViewContainer,
	},
	,
	{
		key: "THREE_SIXTY_DEGREE_VIEW_CONTAINER_NEW",
		path: "/home/three-sixty-degree-view-new/",
		component: ThreeSixtyDegreeViewContainerNew,
	},
	{
		key: "ADMIN_SERVICE_REQUESTS",
		path: "/home/admin-service-requests-old/",
		component: AdminServiceRequestsContainer,
	},
	{
		key: "ADMIN_SERVICE_PROGRESSION",
		path: "/home/admin-service-progression-old/",
		component: AdminServiceProgressionContainer,
	},
	{
		key: "FACILITATOR_SERVICE_PROGRESSION_OLD",
		path: "/home/facilitator-service-progression-old/",
		component: FacilitatorServiceProgressionViewContainer,
	},
	{
		key: "NEWANDENGAGEDUSER_CONTAINER",
		path: "/home/newandengagedusers/",
		component: NewAndEngagedUserHome,
	},
	{
		key: "PARTYINVOICE_CONTAINER",
		path: "/home/partyinvoice/",
		component: PartyInvoiceMainContainer,
	},
	{	
		key: "CLOSEDSERVICE_CONTAINER",
		path: "/home/closedservice/",
		component: ClosedServiceInterface,
	},
	{
		key: "SERVICE_CATALOGUE_VIEW",
		path: "/home/service-catalogue-view/",
		// component: ServiceCatalogueHome,
		component: ServiceCatalogueHome
	},
	{
		key: "PROGRAM_MANAGER_MASTER",
		path: "/home/program-manager-master/",
		component: ProgramManagerMasterHome,
	}
	,
	{
		key: "PARTNER_MASTER",
		path: "/home/partner-master/",
		component: PartnerMasterHome,
	}
	,
	{
		key: "PROGRAM_MANAGER_PARTNER_ASSOCIATION",
		path: "/home/programmanager-partner-association/",
		component: ProgramManagerPartnerAssociationHome,
	},
	{
		key: "RESOURCE_MASTER_VIEW",
		path: "/home/resource-master-view/",
		component: ResourceMasterHome,
	}
	,
	{
		key: "MANAGE_EXTERNAL_PARTNER_VIEW",
		path: "/home/manage_external_partner_view/",
		component: ManageExternalPartnerHome,
	},
	{
		key: "ADMIN_SERVICE_REQUESTS",
		path: "/home/my-service-requests-old/",
		component: ServiceRequestsContainer,
	},
	{
		key: "USERS",
		path: "/home/users/",
		component: UserListContainer,
	},
	{
		key: "REPORTS",
		path: "/home/reports-old/",
		component: ReportContainer,
	},
	{
	  key: "All_SERVICES_REPORT",
	  path: "/home/reports/all-services-report",
	  component: AllServiceReportContainer
	},
	{
		key: "PAYMENT TRACKER REPORTS",
		path: "/home/payment-tracker/",
		component: PaymentTrackerContainer,
	},
	{
		key: "LOGOUT",
		path: "/home/logout/",
		component: LogoutContainer,
	},
	{
		key: "SERVICE_PACKAGING",
		path: "/home/service-packaging/",
		component: ServicePackagingContainer,
	},
	{
		key: "SPLED_DASHBOARD",
		path: "/home/spled-dashboard",
		//component: AdminSPLedDashboardView,
		component:EServicePartnerDashboard
	},
	{
		key: "JPMCDASHBOARD_CONTAINER",
		path: "/home/jpmcdashboard/",
		component: JpmcDashboardContainer,
	},
	{
		key: "ANEKDASHBOARD_CONTAINER",
		path: "/home/anekdashboard/",
		component: AnekDashboardContainer,
	},
	{
		key: "ANEKDASHBOARD_CONTAINER-INTERVENTIONS-AVAILED-REPORTS",
		path: "/home/anekdashboard-interventions-availed-reports/",
		component: InterventionsAvailedReports,
	},
	{
		key: "JPMCEXPENSEDASHBOARD_CONTAINER",
		path: "/home/jpmcexpdashboard/",
		component: JpmcExpenseDashboardContainer,
	},
	{
		key: "ENGAGEDUSERS_CONTAINER",
		path: "/home/engagedusers-container",
		//component: AdminSPLedDashboardView,
		component:EngagedUsersReportContainer
	},
	
	{
		key: 'ASSIGNED_FACILITATORS',
		path: '/home/assignedfacilitators-container',
		component:AssignedFacilitatorContainer
	},

	{
		key: "ENGAGEDUSERS_REPORT",
		path: "/home/engagedusers-report",
		//component: AdminSPLedDashboardView,
		component:EngagedUsersReportDashboard
	},
	
	{
		key: "SPLED_SERVICE_REQUESTS",
		path: "/home/spled-service-requests",
		//component: AdminSPLedServiceRequestsView,
		component:EServicePartnerServiceRequest
	},
	{
		key: "FACILITATOR_KRA_DASHBOARD",
		path: "/home/facilitator-kra-dashboard",
		component: FacilitatorKRADashboardContiner,
	},
	{
		key: "MANAGERS_KRA_DASHBOARD",
		path: "/home/managers-kra-dashboard",
		component: ManagersFacilitatorKRADashboardContainer,
	},
	{
		key: "ADMIN_UPLOAD_REPORT",
		path: "/home/upload-kra-report",
		component: AdminUploadReport,
	},
	{
		key: "SEARCH_USER_BUSINESS_PROFILE",
		path: "/home/search-user-business-profile",
		component: UserProfileSearchAndViewContainer,
	},
	{
		key: "USER_MARK_OUT_OF_OFFICE",
		path: "/home/mark-user-out-of-office",
		component: MarkOutOfOfficeContainer,
	},
	{
		key: "ESP_TARGET_CONFIGURATION",
		path: "/home/sp-target-configuration",
		component: ESPTargetConfiguration,
	},
	{
		key: "DND_USER_LIST",
		path: "/home/dnd-users",
		component: DNDExpirationUsersContainer,
	},
	{
		key: "ADMIN_SERVICE_REQUESTS_ASSIGNMENT",
		path: "/home/admin-service-requests/",
		component: AdminServiceRequestAssignmentContainer,
	},
	{
		key: "ADMIN_SERVICE_PROGRESSION_VIEW",
		path: "/home/admin-service-progression/",
		component: AdminServiceProgressionViewContainer,
	},
	// {
	// 	key: "ADMIN_SERVICE_REQUESTS_NEW",
	// 	path: "/home/my-service-requests/",
	// 	component: MyServiceRequestsContainer,
	// },
	{
		key: "ADMIN_SERVICE_REQUESTS_NEW",
		path: "/home/my-service-requests/",
		component: MyServiceRequestsContainerNew,
	},
	{
		key: "ESPSUBSCRIBERS_CONTAINER",
		path: "/home/espsubscriber/",
		component: ESPSubscribersInterface,
	},
	{
		key:"ADMIN_EXPERT_APPOINTMENT",
		path:'/home/admin-expert-appointment/',
		component: AdminExpertAppointmentContainer,
	},
	{
		key: 'ADMIN_EXPERT_SLOTS',
		path: "/home/admin-expert-slots/",
		component: AdminExpertSlots,
	},
	{
		key:"ADMIN_EXPERT_CALENDAR",
		path: "/home/admin-expert-calendar",
		component: AdminExpertCalendarContainer
	},
	{
		key: "REPORTS",
		path: "/home/reports/",
		component: ReportsContainer,
	},

	{
		key: "FACILITATOR_ACTIONS_VIEW_CONTAINER",
		path: "/home/facilitator-actions-view-container/",
		component:FacilitatorActionsContainer,
	},
	{
		key: "FACILITATOR_ACTIONS_VIEW_CONTAINER_NEW",
		path: "/home/facilitator-actions-view-container-new/",
		component:ToolsTemplatesActionContainer,
	},
	
	{
		key: "FACILITATOR_SERVICE_PROGRESSION",
		path: "/home/facilitator-service-progression/",
		component: FacilitatorServiceProgressionContainer,
	},
	{
		key: "THREE_SIXTY_DEGREE_VIEW_CONTAINER",
		path: "/home/three-sixty-degree-view/",
		component: ThreeSixtyDegreeViewContainer,
	},
	{
		key: "IHCLDASHBOARD_CONTAINER",
		path: "/home/ihcldashboard/",
		component: IhclDashboardContainer,
	},
	{
		key: "JPMC_THREE_SIXTY_DEGREE_VIEW_CONTAINER",
		path: "/home/jpmc-three-sixty-degree-view/",
		component: JpmcThreeSixtyDegreeViewContainer,
	},
	{
		key: "DREAMBIGNEWANDENGAGEDUSER_CONTAINER",
		path: "/home/dreambignewandengagedusers/",
		component: DreamBigNewAndEngagedUserHome,
	},
	{
		key: "JPMC_TESTIMONIALS",
		path: "/home/jpmc-testimonials/",
		component: JPMCTestimonials,
	},
	{
		key: "ADMIN_SERVICE_RESOURCE-ASSIGNMENT",
		path: "/home/admin-resource-requests/",
		component:AdminResourceAssignmentContainer,
	},
	{
		key:"MY_RESOURCE_ASSIGNMENT",
		PATH:"/home/my-resource-assignment/",
		component:MyResourceAssignmentContainer,
	},	

	 
	
	
	//REPORT ROUTE.
];